module.exports = __webpack_public_path__ + "static/media/logo-health.1ea034fc.svg";